import Vue from 'vue';
import Router from 'vue-router';

import Dashboard from "./views/Dashboard.vue";
import MembershipDefault from "./views/ManageMembership/default.vue";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			name: 'dashboard',
			component: Dashboard
		},
		
			
		{
			path: '/membership',
			name: 'manage-membership',
			component: MembershipDefault,
			props: true
		}

	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})
